/**
 * @typedef DamFile
 * @type {object}
 * @property {string} itemId - a unique identifier for the file
 */

export const createFindByProp = prop => compareItem => existingItem =>
  existingItem[prop] === compareItem[prop];

export const createFindByItemId = createFindByProp('itemId');

/**
 * @param {DamFile[]} a - first array of files
 * @param {DamFile[]} b - second array of files
 * @returns {boolean} if the arrays contain the same files, by comparing their itemId
 */
export const fileArrayIsEqual = (a, b) => {
  if (a && !b) {
    return false;
  }
  if (!a && b) {
    return false;
  }

  return a.length === b.length && a.every(aFile => !!b.find(createFindByItemId(aFile)));
};
